module.exports = __webpack_public_path__ + "static/media/Выявление литературно одаренных обучающихся и развитие их филологических способностей статья.pdf";